module.exports = __webpack_public_path__ + "img/checkmark.af575592.svg";